import { render } from "./ServicePublic.vue?vue&type=template&id=54cf51be&scoped=true&ts=true"
import script from "./ServicePublic.vue?vue&type=script&lang=ts"
export * from "./ServicePublic.vue?vue&type=script&lang=ts"

import "./ServicePublic.vue?vue&type=style&index=0&id=54cf51be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cf51be"]])

export default __exports__